export default "__VITE_ASSET__4e60fea2__"